import styled from "styled-components";
import { TasksKanbanProjectWrapper } from "./TasksKanbanProjectWrapper";


export const TasksKanban = ({tasks, projects}) => {

    
    return (
        <StyledTasksKanban>
            {
                projects.map(prj =>
                    {

                        const projectTasks = tasks.filter(tsk => tsk && tsk.taskProjectUuid === prj.projectUuid);

                        if(prj && prj.projectTasks.enabled && projectTasks.length > 0) return <TasksKanbanProjectWrapper key={prj.projectUuid} project={prj} tasks={projectTasks}/>;
                        else return null;
                    }
                )
            }
        </StyledTasksKanban>
    )
}

const StyledTasksKanban = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};
    overflow: auto;
`